export default __webpack_public_path__ + "static/media/project_thumbnail_gridlabs.daa13780.png";